import { IconButton } from '@montugroup/design-system';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <IconButton
      color="primary"
      size="large"
      onClick={() => navigate(-1)}
      sx={(theme) => ({
        padding: 0,
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      })}
    >
      <ChevronLeft fontSize="large" />
    </IconButton>
  );
}
